export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/channel-ota.7bc91c8e-83de32.svg";